type LocalStorageItemData = string | number | object;

type LocalStorageItem = {
    data: LocalStorageItemData;
    expiry: number;
};
// Function to set data in localStorage with a TTL (in milliseconds)
export function setLocalStorageItemWithTTL(localStorageKey: string, data: LocalStorageItemData, ttl: number) {
    const now = Date.now(); // Current timestamp in milliseconds
    const item: LocalStorageItem = {
        data,
        expiry: now + ttl // Expiry time in milliseconds
    };
    localStorage.setItem(localStorageKey, JSON.stringify(item)); // Store as a JSON string
}

// Function to get an item from localStorage with TTL handling
export function getLocalStorageItemWithTTL(localStorageKey: string, defaultValue: LocalStorageItemData | null = null): LocalStorageItemData | null {
    const localStorageItem = localStorage.getItem(localStorageKey); // Retrieve the item
    if (!localStorageItem) {
        return defaultValue; // Key does not exist, return defaultValue
    }

    const item = JSON.parse(localStorageItem); // Parse the JSON string
    const now = Date.now(); // Current timestamp in milliseconds

    // Check if the item has expired
    if (now > item.expiry) {
        localStorage.removeItem(localStorageKey); // Remove expired item.
        return defaultValue; // Return defaultValue for expired items
    }

    return item.data; // Return the stored value
}
